/**
 * OidcSignIn.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { stringMatching } from '../Theme';

function OidcSignIn(_ref) {
  var onClick = _ref.onClick,
      className = _ref.className,
      strings = _ref.strings;
  return React.createElement('div', {
    className: "".concat(className, " form")
  }, React.createElement('label', {
    className: 'fieldsetTitle'
  }, stringMatching(strings, 'Welcome')), React.createElement('button', {
    onClick: onClick,
    className: 'submitButton'
  }, stringMatching(strings, 'login')));
}

export default OidcSignIn;